import Vue from 'vue'
import Router from 'vue-router'
// 多级菜单
// import Layout from '@/views/layout'
// 公共页面
// import MultilevelRouting from '@/components/multilevelRouting'

import { constantRouterMap } from './modules/constant'

Vue.use(Router)

const pageRoute = []
function importAll(r){
  r.keys().forEach(
    (key) => pageRoute.push(r(key).default)
  )
}
importAll(require.context('./modules', true, /\.router\.js/))

const routerMap = [
  ...pageRoute
]
/**
 * 通配路由
 * 如果匹配不到路由则跳转到404
 */
const wildcard = [
  { path: '*', redirect: '/404', hidden: true }
]
const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
export default router
export { constantRouterMap, routerMap, wildcard, pageRoute }
